// Mock data pour le formulaire de contact
export const mockContactSubmissions = [];

export const submitContactForm = (formData) => {
  const submission = {
    id: Date.now(),
    ...formData,
    timestamp: new Date().toISOString()
  };
  mockContactSubmissions.push(submission);
  console.log('Contact form submitted (MOCK):', submission);
  return submission;
};

// Services data
export const servicesData = [
  {
    id: 'infogerance',
    title: 'Infogérance & maintenance au quotidien',
    slug: 'infogerance',
    shortDescription: "J'assure le bon fonctionnement de votre informatique au jour le jour : postes de travail, serveurs, réseau, sauvegardes et mises à jour.",
    icon: 'settings'
  },
  {
    id: 'depannage',
    title: 'Dépannage & support ponctuel à distance',
    slug: 'depannage',
    shortDescription: "Je prends en charge vos incidents et demandes ponctuelles à distance : problèmes de connexion, lenteurs, messages d'erreur, imprimantes, accès à distance, etc.",
    icon: 'wrench'
  },
  {
    id: 'infrastructure',
    title: 'Projets d\'infrastructure',
    slug: 'infrastructure',
    shortDescription: "J'accompagne vos projets d'infrastructure : renouvellement de serveurs, mise en place ou refonte de réseau, déploiement Wi-Fi, segmentation, sécurisation des accès.",
    icon: 'network'
  },
  {
    id: 'm365',
    title: 'Cloud & Microsoft 365',
    slug: 'm365',
    shortDescription: "Je vous aide à migrer ou à structurer vos usages autour de Microsoft 365 : messagerie, partage de fichiers, collaboration, télétravail.",
    icon: 'cloud'
  },
  {
    id: 'securite',
    title: 'Sécurité & sauvegarde',
    slug: 'securite',
    shortDescription: "Je mets l'accent sur la sécurité de vos données : pare-feu, antivirus, filtrage, gestion des droits, sauvegardes locales et cloud.",
    icon: 'shield'
  },
  {
    id: 'conseil',
    title: 'Conseil, audit & DSI à temps partagé',
    slug: 'conseil-dsi',
    shortDescription: "J'interviens comme conseiller externe pour faire le point sur votre informatique : audit de l'existant, identification des risques, priorités et pistes d'amélioration.",
    icon: 'briefcase'
  }
];

// Réalisations / Case studies (cas réels, anonymisés)
export const realisationsData = [
  {
    id: 1,
    type: 'Renouvellement d\'infrastructure - Mairie',
    size: 'Commune de +8 000 habitants • 200+ postes • 30+ VM',
    tags: ['Infrastructure', 'Active Directory', 'PRA', 'Sauvegarde'],
    context: 'Une mairie de plus de 8 000 habitants avec une infrastructure serveur vieillissante, un Active Directory historique nécessitant une refonte, et un plan de reprise d\'activité à structurer pour garantir la continuité du service public.',
    problem: 'Moderniser l\'infrastructure, gagner en performance et en rendement par VM, fiabiliser l\'ensemble, et mettre en place un PRA crédible avec une sauvegarde externalisée.',
    actions: 'Analyse approfondie et élaboration du plan, compréhension fine du besoin métier, refonte complète de l\'Active Directory, migration des 200+ postes utilisateurs et des 30+ VM d\'applications métier. Recyclage intelligent des anciens équipements pour constituer un site PRA et un serveur de sauvegarde externalisé. Accompagnement de bout en bout, anticipation et suivi des effets de bord.',
    results: 'Infrastructure plus performante avec un meilleur rendement par VM, plan de reprise d\'activité concret et testé, sauvegardes externalisées fiables, et une architecture scalable conçue pour durer dans le temps.',
    icon: 'building'
  },
  {
    id: 2,
    type: 'Architecture réseau - Hôtel 4 étoiles',
    size: 'Hôtel 4★ • 300 chambres • Transition numérique',
    tags: ['Réseau', 'Wi-Fi', 'Segmentation', 'Redondance'],
    context: 'Un hôtel 4 étoiles de 300 chambres engagé dans sa transition numérique, nécessitant une architecture réseau d\'entreprise robuste capable de gérer à la fois les usages internes, les clients, et les systèmes critiques (PMS, IoT, IPTV...).',
    problem: 'Concevoir et déployer un réseau d\'entreprise complet : LAN structuré, Wi-Fi haute densité, segmentation des flux, redondance des liaisons et sécurisation globale.',
    actions: 'Étude complète du projet, présentation aux équipes dirigeantes, choix de la stack technologique (équipements, fournisseurs, topologie), conception de l\'architecture, déploiement des équipements actifs et passifs, configuration des VLANs, mise en place de la redondance des liaisons et des politiques de sécurité.',
    results: 'Un réseau d\'entreprise solide et évolutif, une couverture Wi-Fi adaptée à la densité de l\'établissement, une segmentation propre garantissant la sécurité des données critiques, et une infrastructure capable d\'accompagner la croissance numérique de l\'hôtel.',
    icon: 'network'
  },
  {
    id: 3,
    type: 'Supervision & automatisation - Parc multi-sites',
    size: '300+ postes • 600+ équipements réseau • 30+ VM',
    tags: ['Monitoring', 'Supervision', 'Automatisation', 'Sécurité'],
    context: 'Un parc important et hétérogène à superviser : plus de 300 postes clients, 600 équipements réseau et 30 VM, sans visibilité centralisée ni capacité à anticiper les pannes ou vulnérabilités.',
    problem: 'Mettre en place une supervision complète, automatiser les tâches récurrentes, et passer d\'une posture réactive à une approche proactive sur la sécurité et la disponibilité.',
    actions: 'Déploiement d\'outils de monitoring et de supervision, création de politiques adaptées à chaque type d\'équipement, mise en place d\'alertes de sécurité ciblées, automatisation des tâches répétitives. Architecture pensée pour être simple, scalable et facilement maintenable dans le temps.',
    results: 'Vision en temps réel sur l\'ensemble du parc, détection précoce des pannes et des CVE, réduction significative des incidents, capacité à intervenir avant que les utilisateurs ne soient impactés, et une équipe IT qui passe d\'un mode "pompier" à un mode pilotage.',
    icon: 'monitor'
  },
  {
    id: 4,
    type: 'MCO postes & serveurs - Panel multi-clients',
    size: '~20 clients • TPE, grands groupes, secteur public',
    tags: ['Maintenance', 'MCO', 'Conseil', 'Multi-clients'],
    context: 'Un panel d\'une vingtaine de clients variés (TPE, PME, grands groupes, sociétés publiques) avec des parcs hétérogènes et des besoins de maintien en condition opérationnelle au quotidien.',
    problem: 'Assurer un MCO de qualité sur des environnements très différents, traiter rapidement les pannes, mais surtout anticiper grâce à la supervision pour éviter les incidents critiques.',
    actions: 'Interventions régulières sur site et à distance, maintien proactif des postes et serveurs, traitement des pannes au fil de l\'eau, analyse continue de la supervision pour anticiper les défaillances. Conseil personnalisé à chaque client sur les bonnes pratiques, l\'identification des équipements critiques à renouveler et l\'évolution de leur infrastructure.',
    results: 'Une relation de confiance durable avec chaque client, un parc maintenu en bonne santé, des incidents évités grâce à l\'anticipation, et des décisions d\'investissement éclairées qui maximisent le ROI sur les équipements critiques.',
    icon: 'wrench'
  },
  {
    id: 5,
    type: 'Migration Microsoft 365 - Multi-clients',
    size: 'De quelques utilisateurs à plusieurs dizaines par client',
    tags: ['Microsoft 365', 'Migration', 'Cloud', 'Conduite du changement'],
    context: 'Plusieurs clients souhaitant moderniser leurs usages numériques en migrant vers Microsoft 365 : messagerie, collaboration, partage de fichiers, télétravail. Des contextes variés, des cultures d\'entreprise différentes, des niveaux de maturité IT hétérogènes.',
    problem: 'Réussir des migrations sans interruption d\'activité, avec un accompagnement humain pour que les équipes adoptent réellement les nouveaux outils, et non qu\'elles les subissent.',
    actions: 'Analyse de l\'impact pour chaque client, coordination des équipes internes et externes, élaboration d\'un plan d\'action détaillé, réalisation des migrations (mailboxes, fichiers, identités), formation et accompagnement des utilisateurs, support post-migration et ajustements en continu.',
    results: 'Des migrations réussies sans perte de données ni de productivité, des équipes qui utilisent pleinement les nouveaux outils (Teams, SharePoint, OneDrive), une collaboration améliorée, et une meilleure maîtrise des coûts grâce à l\'optimisation des licences.',
    icon: 'cloud'
  },
  {
    id: 6,
    type: 'Conseil & audit - Accompagnement stratégique',
    size: 'Missions ponctuelles ou récurrentes selon les besoins',
    tags: ['Audit', 'Conseil', 'Stratégie IT', 'Bonnes pratiques'],
    context: 'Des entreprises qui ressentent le besoin de prendre du recul sur leur informatique, sans nécessairement avoir les ressources internes pour le faire : audit de l\'existant, identification des risques, choix de prestataires, arbitrage des investissements.',
    problem: 'Apporter un regard externe expert, indépendant et pragmatique pour aider les dirigeants à prendre les bonnes décisions sur leur informatique, sans jargon et sans biais commercial.',
    actions: 'Audits techniques complets, cartographie des risques et des points de vigilance, recommandations priorisées et chiffrées, accompagnement dans le choix de solutions et de partenaires, suivi de projets, veille sur les bonnes pratiques et les évolutions technologiques pertinentes pour chaque contexte.',
    results: 'Des dirigeants qui prennent des décisions éclairées sur leur IT, des budgets mieux maîtrisés, des risques identifiés et adressés, et une informatique qui sert vraiment la stratégie de l\'entreprise plutôt que de la subir.',
    icon: 'briefcase'
  }
];

// Method steps
export const methodSteps = [
  {
    number: 1,
    title: 'Prise de contact & échange initial',
    duration: '30 min visio',
    description: 'Nous faisons un premier point en visio de 30 minutes pour comprendre votre contexte, vos enjeux et vos urgences, sans jargon et sans engagement.'
  },
  {
    number: 2,
    title: 'Audit / état des lieux',
    duration: 'Sur site ou à distance',
    description: 'Je réalise un état des lieux de votre infrastructure (matériel, réseau, sauvegardes, usages) afin d\'identifier clairement les points forts, les risques et les priorités.'
  },
  {
    number: 3,
    title: 'Plan d\'action & mise en œuvre',
    duration: 'Selon projet',
    description: 'Je vous propose un plan d\'action concret et réaliste, puis je prends en charge la mise en œuvre des actions retenues : corrections rapides, projets structurants, accompagnement des équipes.'
  },
  {
    number: 4,
    title: 'Suivi et ajustements dans la durée',
    duration: 'Continu',
    description: 'Une fois votre informatique stabilisée, je reste disponible pour le suivi, les ajustements et les nouveaux besoins, avec une relation de proximité et un interlocuteur unique qui connaît votre entreprise.'
  }
];
